import http from '@/core/http';
import * as Types from './types';
import { ACCESS_TYPE_ENUM } from '@/api/uacs/auth/constant';

/**
 * 登录
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/1247
 */
export const authLogin = (params: Types.IAuthLoginReq) => {
  const url = '/uacs/api/auth/login';
  return http.post<Types.IAuthLoginRes>({
    url,
    data: params,
    loading: true,
  });
};

/**
 * 登出
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/1248
 */
export const authLogout = () => {
  const url = '/uacs/api/auth/logout';
  return http.post({
    url,
    loading: true,
    showErrorMessage: false,
  });
};

/**
 * 选择租户并登录
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/1431
 */
export const authTenantLogin = (params: { tenantId: string; organizationId?: string; }) => {
  const url = '/uacs/api/auth/tenantLogin';
  return http.post<{ token: string; }>({
    url,
    params,
    loading: true,
    showErrorMessage: false,
  });
};

/**
 * 检查登录状态
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/2285
 */
export const authCheckLogin = () => {
  const url = '/uacs/api/auth/checkLogin';
  return http.get<boolean>({
    url,
    loading: true
  });
};

/**
 * 访问应用
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/3604
 */
export const authReportAction = (params: { clientCode: string; accessType: ACCESS_TYPE_ENUM; }) => {
  const url = '/uacs/api/auth/reportAction';
  return http.post({
    url,
    data: params,
    loading: true
  });
};

/**
 * 访问应用
 * @see apifox: https://app.apifox.com/link/project/6658774/apis/api-377749484
 */
export const authActiveSessions = (params: { tenantId: string; }) => {
  const url = '/uacs/api/auth/activeSessions';
  return http.get<Types.UserSession[]>({
    url,
    params,
    loading: true
  });
};

/**
 * 根据token注销会话
 * @see https://app.apifox.com/link/project/6658774/apis/api-377765866
 */
export const authLogoutByToken = (params: { token: string; }) => {
  const url = '/uacs/api/auth/logoutByToken';
  return http.post({
    url,
    params,
    loading: true
  });
};
